import { getCookie, setCookie, setCookieConsent, setGpsCookie, getGpsCookie, unsetCookie, getTextCookie, setTextCookie } from './cookies';

(window as any).ts = { getCookie, setCookie, setCookieConsent, unsetCookie, getTextCookie, setTextCookie, setGpsCookie, getGpsCookie };